export default "__VITE_ASSET__cb58bcc5__"